export const blockIconsPlacesBusinessCenter = (
	<span className='material-symbols-outlined'>business_center</span>
);
